import { IRanking } from './Ranking.interface';

export const initialState: Array<IRanking> = [];
